import { useMutation, UseMutationResult } from '@tanstack/react-query';
import {
  updateChainStoreContract,
  uploadChainStoreAttachment,
  deleteChainStoreAttachment,
} from '../../api/chain-store-contract.ts';
import type {
  UpdateChainStoreContractRequest,
  UploadChainStoreContractAttachmentRequest,
  DeleteChainStoreContractAttachmentRequest,
} from '../../api/requests/chain-store-contract-request.ts';

async function updateAll(
  updateRequest?: UpdateChainStoreContractRequest,
  uploadRequest?: UploadChainStoreContractAttachmentRequest,
  deleteRequest?: DeleteChainStoreContractAttachmentRequest,
) {
  const promises = [];
  if (updateRequest) {
    promises.push(updateChainStoreContract(updateRequest));
  }
  if (uploadRequest) {
    promises.push(uploadChainStoreAttachment(uploadRequest));
  }
  if (deleteRequest) {
    promises.push(deleteChainStoreAttachment(deleteRequest));
  }
  await Promise.all(promises);
}

export default function useUpdatePartner(): UseMutationResult<
  void,
  Error,
  [
    UpdateChainStoreContractRequest | null,
    UploadChainStoreContractAttachmentRequest | null,
    DeleteChainStoreContractAttachmentRequest | null,
  ]
> {
  return useMutation({
    mutationFn: ([updateRequest, uploadRequest, deleteRequest]) =>
      updateAll(updateRequest, uploadRequest, deleteRequest),
  });
}
